<!-- PAGE LOADER -->
<div class="page-progress">
  <mat-progress-bar mode="indeterminate" *ngIf="moduleLoading"></mat-progress-bar>
</div>

<div class="content-grid">
  <div class="app-hub-content">
    <div class="app-sidebar-container" [ngClass]="{'full-width': !navService.sidebarState.sidenavOpen}">
      <!-- Sidebar -->
      <div class="app-sidebar-wrap">
        <app-sidebar class="sidebar-wrapper"></app-sidebar>
      </div>
      <!-- Content page -->
      <div class="app-content-wrap">
        <!-- Header -->
        <app-header></app-header>
        <div class="app--body-container">
          <router-outlet></router-outlet>
          <!-- <button class="btn" id="add-takeaway-btn"><img src="./assets/images/icons/plus.svg" alt=""></button> -->
        </div>

        <app-actions-bar></app-actions-bar>

      </div>
    </div>
  </div>
</div>
